module.exports = __webpack_public_path__ + "img/horizontal_7_2_9006.f5880e13.png";